export const themeConstants = {
  primary: {
    gradient: 'linear-gradient(90deg, #F51F55 0%, #F53034 100%)',
    main: '#F53034',
    light: '#F51F55',
    dark: '#d41616',
    contrastText: '#fff',
  },
  secondary: {
    gradient: 'linear-gradient(90deg, #2196F3 0%, #1976D2 100%)',
    main: '#1976D2',
    light: '#2196F3',
    dark: '#0D47A1',
    contrastText: '#fff',
  },
};
